import { ChangeEvent } from 'react';
import { InterruptionModel } from '../models/interruptions/interruptionList.model';

/**
 * Esta funcion recibe la lista de interrupciones y se encarga de la logíca de los cambios de las fechas
 * @param isStartDate boolean
 * @param list InterruptionModel[][]
 * @param interruptionIndex number
 * @param target ChangeEvent<HTMLInputElement>,
 * @param employeeId number
 * @returns InterruptionModel[][]
 */
export const changeDate = (
    isStartDate: boolean,
    list: InterruptionModel[][],
    interruptionIndex: number,
    { target }: ChangeEvent<HTMLInputElement>,
    employeeId: number
) => {
    let interrup = [...list];

    let interrupCopy = [...list][employeeId];

    let interruptionCopy = interrupCopy.map((i) => {
        let add = { ...i };

        if (add.id === interruptionIndex) {
            if (isStartDate) {
                add!.startDate =
                    add!.startDate.split('T')[0] + 'T' + target.value + ':00';
            } else {
                add!.endDate =
                    add!.endDate.split('T')[0] + 'T' + target.value + ':00';
            }
        }
        return add;
    });

    interrup[employeeId] = [...interruptionCopy];

    return interrup;
};
